/**
 * Phase 18 — render helpers shared between web + React Native.
 * Pure functions only; UI components import these.
 */

import type { RemodelRender, RenderPayload, RenderStatus } from "./api/types.gen";

export const TERMINAL_RENDER_STATUSES: ReadonlySet<RenderStatus> = new Set([
  "complete",
  "approved",
  "rejected",
  "failed",
]);

const STATUS_LABEL: Record<RenderStatus, string> = {
  pending: "Queued",
  generating: "Rendering",
  complete: "Ready",
  approved: "Approved",
  rejected: "Rejected",
  failed: "Failed",
};

export function formatRenderStatus(status: RenderStatus): string {
  return STATUS_LABEL[status];
}

export function isTerminalStatus(status: RenderStatus): boolean {
  return TERMINAL_RENDER_STATUSES.has(status);
}

export function isApproved(render: Pick<RemodelRender, "status">): boolean {
  return render.status === "approved";
}

/**
 * Seconds left until `estimated_ready_at`. Returns `null` if no ETA was
 * server-supplied OR the ETA is already past. Used by the spinner copy
 * ("Rendering — about 8 seconds left").
 */
export function secondsUntilReady(
  payload: Pick<RenderPayload, "estimated_ready_at">,
  now: Date = new Date(),
): number | null {
  if (!payload.estimated_ready_at) return null;
  const target = new Date(payload.estimated_ready_at).getTime();
  const remaining = Math.round((target - now.getTime()) / 1000);
  return remaining > 0 ? remaining : null;
}
